var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom_pagination" }, [
    _c("div", { staticClass: "col-12 override-padding" }, [
      _c(
        "div",
        { staticClass: "col-lg-10 col-md-8 override-padding float-left" },
        [
          _c(
            "div",
            { staticClass: "pagination-width float-left override-padding" },
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  "first-text": "<<",
                  "prev-text": "<",
                  "next-text": ">",
                  "last-text": ">>",
                  "hide-goto-end-buttons": false
                },
                on: { input: _vm.showPaginatedFunction },
                model: {
                  value: _vm.currentPageValue,
                  callback: function($$v) {
                    _vm.currentPageValue = $$v
                  },
                  expression: "currentPageValue"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "goto-width float-left override-padding" }, [
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c(
                "span",
                {
                  staticClass:
                    "col-lg-6 col-md-6 float-left override-padding pad-top"
                },
                [_vm._v("\n            Go to page: \n          ")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "col-lg-4 col-md-6 float-left override-padding"
                },
                [
                  _c("b-form-select", {
                    staticClass:
                      "col-md-10 input-height-30 padding-lr-5 margin-bottom-5",
                    attrs: { options: _vm.pageOptions },
                    on: { change: _vm.showPaginatedFunction },
                    model: {
                      value: _vm.currentPageValue,
                      callback: function($$v) {
                        _vm.currentPageValue = $$v
                      },
                      expression: "currentPageValue"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "goto-width float-left override-padding" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "span",
                {
                  staticClass:
                    "col-lg-6 col-md-6 float-left override-padding pad-top"
                },
                [_vm._v("\n            Row count:\n          ")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "col-lg-6 col-md-6 float-left override-padding"
                },
                [
                  _c("b-form-select", {
                    staticClass:
                      "col-md-12 input-height-30 padding-lr-5 margin-bottom-5",
                    attrs: { options: _vm.perPageOptions },
                    on: { change: _vm.showPerPageFunction },
                    model: {
                      value: _vm.perPageValue,
                      callback: function($$v) {
                        _vm.perPageValue = $$v
                      },
                      expression: "perPageValue"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-lg-2 col-md-4 override-padding float-right text-align-right pad-top"
        },
        [
          _vm._v(
            "\n      Showing " +
              _vm._s(_vm.sNo + 1) +
              "-" +
              _vm._s(_vm.getPageLastNo()) +
              " of " +
              _vm._s(_vm.totalRows) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d7fef72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7fef72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/enterprise_admin_pagination.vue
// module id = null
// module chunks = 